
  import { Component, Prop, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import previewImg from './previewImg.vue';
	import { imgHost } from '@/utils/config';
  @Component({  
    name: '',
    components: {
      PageFooter,
      previewImg
    }
  })

  export default class ProductList extends Vue {
    @Prop({default:''}) private src:string
    @Prop ({default:()=>{return []}}) private previewlist!:any
    private showPreview = false
    private currentUrl = ''
    private imgHost = imgHost

    private getpreivewlist(){
			// console.log(this.previewlist)
			return this.previewlist.map(v=>{
				return this.imgHost + v
			})
		}
  }
